import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
import NotFoundView from './components/404.vue'

// Import Views - Dash
import TablesView from './components/views/Tables.vue'
import TasksView from './components/views/Tasks.vue'
import SettingView from './components/views/Setting.vue'
import AccessView from './components/views/Access.vue'
import ServerView from './components/views/Server.vue'
import ReposView from './components/views/Repos.vue'
import NodeWrapper from './components/views/NodeWrapper.vue'
import ShopWrapper from './components/views/shopcart/ShopWrapper.vue'
import OrdersArchive from './components/views/shopcart/OrdersArchive.vue'
import OrderDetail from './components/views/shopcart/OrderDetail.vue'
import Preferences from './components/views/Preferences.vue'

/* // DevViews
import DevView from './components/views/dev/DevView.vue' */

// Routes
const routes = [{
    path: '/login',
    component: LoginView
  },
  {
    path: '/',
    component: DashView,
    children: [{
      path: 'detail/:id',
      component: NodeWrapper,
      name: 'wrapper',
      meta: {
        description: ''
      }
    }, {
      path: 'detail/:id/:focus',
      component: NodeWrapper,
      name: 'wrapper_focus',
      meta: {
        description: ''
      }
    },/*  {
      path: 'dev',
      component: DevView,
      name: 'Dev',
      meta: {
        description: 'Routing View for Testing and Development purposes'
      }

    }, */ {
      path: 'shopwrapper',
      component: ShopWrapper,
      name: 'ShopCart',
      meta: {
        description: 'Shopping cart test page'
      }
    }, {
      path: 'ordersarchive',
      component: OrdersArchive,
      name: 'OrdersArch',
      meta: {
        description: 'Shopping cart test page'
      }
    }, {
      path: 'orderdetail/:id',
      component: OrderDetail,
      name: 'OrderDetail',
      meta: {
        description: ''
      }
    }, {
      path: 'preferences',
      component: Preferences,
      name: 'preferences'
    }]
  }, {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js